module.exports = __webpack_public_path__ + "img/bo-block-logo.a11564de.svg";